"use client";
import { useCallback, useRef } from "react";
import { useJuneSo } from "@stadium/services/june-analytics/hooks/use-june-so";
import useRouteChange from "@stadium/hooks/lib/use-route-change";

export const useJuneSoPageTracker = ({
  isAuthenticated,
  isFetchingUser,
}: {
  isAuthenticated: boolean;
  isFetchingUser: boolean;
}) => {
  const lastTrackedUrl = useRef("");

  const { isJuneSoScriptLoaded, isUserDataLoaded, isLoggedInUserBlackListed } = useJuneSo();

  const handleRouteChange = useCallback((url: string) => {
    if (
      isJuneSoScriptLoaded &&
      ((!isAuthenticated && !isFetchingUser) || (isUserDataLoaded && !isLoggedInUserBlackListed))
    ) {
      // avoid double tracking
      // - in case next router becomes ready and triggers a routeChangeComplete
      if (url === lastTrackedUrl.current) {
        return;
      }
      lastTrackedUrl.current = url;
      return window?.analytics?.page?.();
    }
  },[]);

  useRouteChange(handleRouteChange);
};
